import React, {Component} from 'react'
import FormMixin from 'containers/shared/FormMixin'
import {connect} from 'react-redux'
import {ConfirmationDialog} from 'components'
import {TransactionActions} from 'actionsets'

class TransactionDialog extends FormMixin(Component) {
  constructor(props){
    super(props)
    this.onSaveRoute = null

    TransactionActions.bindActions(this)
  }

  get formObject() {
    return {allocationId: (this.props.allocation || {}).id, ...this.props.transaction}
  }

  get formObjectName() {
    return 'Transaction'
  }

  get createMode() {
    return true
  }

  handleClose = () => {
    this.props.onClose(false)
  }

  handleSave = async () => {
    await this.save()
    this.props.onClose(true)
  }

  render = () => {
    const {NumberField, TextField} = this
    return (
      <ConfirmationDialog
        title={`Add Transaction`}
        open={!!this.props.allocation}
        onCancel={this.handleClose}
        onConfirm={this.handleSave}
        cancelLabel='Cancel'
        confirmLabel='Save'
      >
        <NumberField attribute="amount" />
        <TextField attribute="paymentIdentifier" label="Transaction Id" />
      </ConfirmationDialog>
    )
  }
}

export default connect(({transactions}) => {
  return { ...transactions }
})(TransactionDialog)